import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/workflows/user-workflows/{userWorkflowId}/activity';
type THIS_API = ApiDefinition['/workflows/user-workflows/{userWorkflowId}/activity']['POST'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const createUserWorkflowActivity = async ({ userWorkflowId, ...body }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { userWorkflowId });
  const response = await noodleApiClient.post(path, body);
  return response.data;
};

export default createUserWorkflowActivity;
